import { render, staticRenderFns } from "./CompanyTaxSettings.vue?vue&type=template&id=0d8728ae"
import script from "./CompanyTaxSettings.vue?vue&type=script&lang=js"
export * from "./CompanyTaxSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports